import { Icon } from "@/ds";

import type { LocalConflictBadgeProps } from "./types-local-conflict-badge";
import styles from "./local-conflict-badge.module.scss";

export function LocalConflictBadgeView({ label, count }: LocalConflictBadgeProps) {
  return (
    <span
      className={styles.badge}
      data-testid="gantt-conflict-badge"
      aria-label={`${count} ${count === 1 ? "Conflito detectado" : "Conflitos detectados"}`}
    >
      <Icon name="exclamation-triangle" size={10.5} />
      {label}
    </span>
  );
}
